import { render, staticRenderFns } from "./ImportantGrid.vue?vue&type=template&id=71e54b84&scoped=true&lang=pug&"
import script from "./ImportantGrid.vue?vue&type=script&lang=ts&"
export * from "./ImportantGrid.vue?vue&type=script&lang=ts&"
import style0 from "./ImportantGrid.vue?vue&type=style&index=0&id=71e54b84&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71e54b84",
  null
  
)

export default component.exports